import { Injectable } from '@angular/core';
import { ProxyService } from '@core/services';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import * as _ from 'lodash-es';
import { Address } from '@shared/cms/models/group-dining-request';
import { DeliveryAddress, ValidateAddressRequest, ValidateAddressResponse } from '@app/core/redux/stores';

@Injectable()
export class AddressService {

  public validatedAddresses: ValidateAddressResponse;
  constructor(private proxyService: ProxyService) {
  }

  validateAddress(address: ValidateAddressRequest) {
    return this.proxyService.httpPost(ApiRoutes.ADDRESS_VERIFICATION, address);
  }

  isSameAddress(s: Address, t: Address) {
    if (!s.line2) {
      s.line2 = '';
    }
    if (!t.line2) {
      t.line2 = '';
    }
    return s.line1.toUpperCase() === t.line1.toUpperCase()
      && s.line2.toUpperCase() === t.line2.toUpperCase()
      && s.city.toUpperCase() === t.city.toUpperCase()
      && s.state.toUpperCase() === t.state.toUpperCase()
      && s.zipCode.toUpperCase() === t.zipCode.toUpperCase();
  }

  getDisplayAddress(address: Address): string {
    let displayAddress = address.line1;
    if (address.line2) {
      displayAddress = displayAddress + '<br />' + address.line2;
    }
    displayAddress = displayAddress + '<br />' + address.city + ', ' + address.state + ' ' + address.zipCode;
    return displayAddress;
  }

  getDeliveryAddressList() {
    return this.proxyService.httpGet(ApiRoutes.DELIVERY_ADDRESSES);
  }
  saveDeliveryAddress(deliveryAddress: DeliveryAddress) {
    return this.proxyService.httpPost(ApiRoutes.DELIVERY_ADDRESSES, deliveryAddress);
  }
  deleteDeliveryAddress(id) {
    return this.proxyService.httpDelete(ApiRoutes.DELIVERY_ADDRESSES + '/' + id, '');
  }
  updateDeliveryAddress(deliveryAddress: DeliveryAddress) {
    return this.proxyService.httpPut(ApiRoutes.DELIVERY_ADDRESSES + '/' + deliveryAddress.id, deliveryAddress);
  }
}
